import { ReadiedRoute, Redirect } from "@itandi/tools/next";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/deals/[id]/detail/Page";

export function Page() {
	return (
		<VendorLayoutV2>
			<ReadiedRoute fallback={<Redirect url="/vendors" />}>
				<Component />
			</ReadiedRoute>
		</VendorLayoutV2>
	);
}
